import { usePlanRoot } from "lib/use-plan-root"
import { Box, Link, ListItem, Stack, Typography } from "@mui/material"
import { navigate } from "lib/routes/navigate"

export function LocationSummary({ item }) {
    const planRoot = usePlanRoot()

    return (
        <ListItem>
            <Stack direction="row" spacing={0.5}>
                <Box minWidth={20} textAlign="right">
                    <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                        {item.count}
                    </Typography>
                </Box>
                <Box>
                    <Link onClick={go}>
                        <Typography variant="caption">in {item.value[0]}</Typography>
                    </Link>
                </Box>
            </Stack>
        </ListItem>
    )

    function go() {
        navigate(`/app/schedules?id=~${planRoot.id}!${item.tasks.items[0].scheduleId.split("!").at(0)}`)
    }
}
